import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import RemoveIcon from '@mui/icons-material/RemoveCircleOutline';
import { useDisplayInfo } from 'hooks/useDisplayInfo';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './option-item-quantity.styles';
import OptionItemLabel from '../option-item-label/option-item-label.component';
import { useOptionItemQuantity } from './option-item-quantity.hooks';
import { convertCentsToDollar } from 'utils';
import MenuDialogContext from 'hooks/dialog/menu-dialog.context';
import Calories from 'pages/menu/menu-modal/calories/calories.component';

const OptionItemQuantity = props => {
  const { item, isItemOutOfStock } = props;
  const { price, lockedModifier, minQuantity, displayInfo } = item;
  const { t } = useTranslation();
  const { title, smallImage } = useDisplayInfo(displayInfo);
  const { handleAdd, handleRemove, qty, isMaxSelectionsReached } =
    useOptionItemQuantity(props);
  const { catalog } = useContext(MenuDialogContext);

  return (
    <S.QuantityContainer data-testid="OptionItem">
      <Box data-testid="OptionItemQuantity.QtyContainer">
        <S.QtyButton
          color="primary"
          aria-label={t('checkout.items.modifierQuantity.decrement', {
            title,
            qty,
            price: convertCentsToDollar(price),
          })}
          onClick={handleRemove}
          data-testid="OptionItemQuantity.Decrease"
          disabled={
            qty === 0 ||
            (lockedModifier && qty === (minQuantity ?? 1)) ||
            isItemOutOfStock
          }
        >
          <RemoveIcon fontSize="medium" />
        </S.QtyButton>
        <Box component="span" display="inline-flex">
          {qty}
        </Box>
        <S.QtyButton
          color="primary"
          aria-label={t('checkout.items.modifierQuantity.increment', {
            title,
            qty,
            price: convertCentsToDollar(price),
          })}
          onClick={handleAdd}
          data-testid="OptionItemQuantity.Increase"
          disabled={
            (item.maxQuantity !== 0 && qty === item.maxQuantity) ||
            isMaxSelectionsReached ||
            isItemOutOfStock
          }
        >
          <AddIcon fontSize="medium" />
        </S.QtyButton>
      </Box>
      <S.OptionQuantityContainer>
        <OptionItemLabel
          isItemOutOfStock={isItemOutOfStock}
          title={title}
          price={price}
          smallImage={smallImage}
        />
      </S.OptionQuantityContainer>
      <Calories
        catalogExtendedAttributes={catalog?.extendedAttributes}
        calories={item.calories}
      />
    </S.QuantityContainer>
  );
};

export default OptionItemQuantity;
